import axios from "axios";
const instance = axios.create({
  baseURL: process.env.VUE_APP_USERS_API_URL,
});

export default {
  // createUser: async function (formData) {
  //   try {
  //     const response = await instance.post("user", formData);
  //     return response;
  //   } catch (error) {
  //     return error.response;
  //   }
  // },

  getDummyUsers: async function (query) {
    try {
      const response = await instance.get('dummy-users'+query)
      return response
    }
    catch (error) {
      console.error(error);
      return error.response;
    }
  },
  getOrganisationTypes: async function (){
      try {
      const response = await instance.get('organisationTypes')
      return response;
    }catch (error){
      return error.response
    }
  },
  getCampaignTypes: async function (){
      try {
      const response = await instance.get('campaignTypes')
      return response;
    }catch (error){
      return error.response
    }
  },
  getHrisUsers: async function (query){
      try {
      const response = await instance.get('fetchHrisMappedUsers'+query)
      return response;
    }catch (error){
      return error.response
    }
  },
  getHrisRolesFromRbacById: async function (query){
      try {
      const response = await instance.get('getHrisRolesByRbacId'+query)
      return response;
    }catch (error){
      return error.response
    }
  },
  bulkCreateUsers: async function (usersData) {
    try {
      const response = await instance.post("bulkUsers", usersData);
      return response;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },
  getUsers: async function () {
    try {
      const response = await instance.get("users");
      return response;
    } catch (error) {
     
      return error.response;
    }
  },
  getSchoolAddresss: async function (query){
    try {
      const response = await instance.get('getSchoolAddress'+query)
      return response;
    }catch (error){
      return error.response
    }
  },
  updateUserInfo: async function (data, id) {
    try {
      console.log("update data for personal info ", data, "id is", id);
      const response = await instance.put(
        "user?userId=" + id,
        data
        //     , {
        //     headers: {
        //         'Authorization': AuthService.getToken()
        //     }
        // }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },
  
 
  deleteUser: async function (obj) {
    try {
      const response = await instance.delete("users", {
        data: obj,
      });
      return response;
    } catch (error) {
      return error.response;
    }
  },

  filteredUsers: async function (data) {
    try {
      const response = await instance.post("filteredUsers" , data);
      return response;
    } catch (error) {
      return error.response;
    }
  },
  resetAdminPassword: async function (email, newPassword) {
    try{
      const response = await instance.post("reset-password", {email, newPassword})
      return response.data;
    }
    catch(error){
      return error.response;
    }
  },

  fetchRBACRoles: async function () {
    try{
      const response = await instance.get("getRBACRoles")
      return response.data;
    }
    catch(error){
      return error.response;
    }
  },

  getHiringManagerEmail: async function (query) {
    try {
     const response = await instance.get("getHiringManagerDetails"+query);
    return response;  
    } catch (error) {
      return error.response;
    }
  },
  validateMDMEmail: async function (email) {
    try{
      const response = await instance.get(`/validateMDMEmail?email=${email}`);
      return response.data;
    }
    catch(error){
      return error.response;
    }
  },
  getUserHistory: async function (userId,campaignId) {
    try {
      let url = `/userProfileHistory?userId=${userId}`;
      if (campaignId !== undefined) {
        url += `&campaignId=${campaignId}`;
      }
      const response = await instance.get(url);
      return response.data;
    }
    catch(error){
      return error.response
    }
  },
  
  getInterviewerDetails: async function (query="") {
    try {
      const response = await instance.get(`/getInterviewerDetails${query}`)
      return response.data;
    }
    catch(error){
      return error.response
    }
  },
  getUserInfo: async function (userId) {
    try {
      const response = await instance.get(`/user?userId=${userId}`)
      return response.data;
    }
    catch(error){
      return error.response
    }
  },
  getUsersCurrentInterviewStatus: async function (userId,campaignId) {
    try {
      let url = `/userCurrentInterviewStatus?userId=${userId}`;
      if (campaignId !== undefined) {
        url += `&campaignId=${campaignId}`;
      }
      const response = await instance.get(url);
      
      return response.data;
    }
    catch(error){
      return error.response
    }
  },

  updateUser: async function (userId, payload) {
    try{
      const response = await instance.put(`user?userId=${userId}`, payload);
      return response.data;
    }
    catch(error){
      console.error(error.response)
      return error.response;
    }
  },
  getMasterFilters: async function (docId) {
    try {
      const response = await instance.get(`get-master-filters/${docId}`);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },

  
  clearHMDraft: async function (payload) {
    try {
      const response = await instance.post("clearHMDraft", payload);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
};
